"use strict"; // Copyright 2012 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js");

var _inherits = require("/vercel/path0/node_modules/@babel/runtime/helpers/inherits.js");

var _possibleConstructorReturn = require("/vercel/path0/node_modules/@babel/runtime/helpers/possibleConstructorReturn.js");

var _getPrototypeOf = require("/vercel/path0/node_modules/@babel/runtime/helpers/getPrototypeOf.js");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AuthClient = void 0;

var events_1 = require("events");

var transporters_1 = require("../transporters");

var AuthClient = /*#__PURE__*/function (_events_1$EventEmitte) {
  _inherits(AuthClient, _events_1$EventEmitte);

  var _super = _createSuper(AuthClient);

  function AuthClient() {
    var _this;

    _classCallCheck(this, AuthClient);

    _this = _super.apply(this, arguments);
    _this.transporter = new transporters_1.DefaultTransporter();
    _this.credentials = {};
    return _this;
  }
  /**
   * Sets the auth credentials.
   */


  _createClass(AuthClient, [{
    key: "setCredentials",
    value: function setCredentials(credentials) {
      this.credentials = credentials;
    }
    /**
     * Append additional headers, e.g., x-goog-user-project, shared across the
     * classes inheriting AuthClient. This method should be used by any method
     * that overrides getRequestMetadataAsync(), which is a shared helper for
     * setting request information in both gRPC and HTTP API calls.
     *
     * @param headers objedcdt to append additional headers to.
     */

  }, {
    key: "addSharedMetadataHeaders",
    value: function addSharedMetadataHeaders(headers) {
      // quota_project_id, stored in application_default_credentials.json, is set in
      // the x-goog-user-project header, to indicate an alternate account for
      // billing and quota:
      if (!headers['x-goog-user-project'] && // don't override a value the user sets.
      this.quotaProjectId) {
        headers['x-goog-user-project'] = this.quotaProjectId;
      }

      return headers;
    }
  }]);

  return AuthClient;
}(events_1.EventEmitter);

exports.AuthClient = AuthClient;